import { BlockProps, LinkProps } from "@/utils/types";
import { BlockWrapper } from "./BlockWrapper";
import { Portable } from "../utility/Portable";
import { sanitize } from "@/utils/sanitize";
import { isExternal } from "@/utils/isExternal";

type LinkItem = {
  _key: string;
} & LinkProps;

export interface RichTextProps extends BlockProps {
  copy: any[];
  links?: LinkItem[];
}

export const RichText = ({
  backgroundColor = "bg-white",
  bottom,
  className,
  colorStarter,
  componentId,
  heading,
  primaryEnder,
  links,
  ...props
}: RichTextProps) => {
  const lightMode =
    sanitize(backgroundColor) === "bg-white" ||
    sanitize(backgroundColor) === "pattern" ||
    sanitize(backgroundColor) === "bg-secondary" ||
    sanitize(backgroundColor) === "bg-tertiary";

  const boxStyles =
    sanitize(backgroundColor) === "waves"
      ? "bg-white rounded-lg shadow-md text-black py-8"
      : sanitize(backgroundColor) === "pattern"
        ? "bg-secondary rounded-lg shadow-md text-black font-semibold py-8"
        : lightMode
          ? "text-black"
          : "text-white font-semibold";

  const boxHeadingStyles =
    sanitize(backgroundColor) === "waves"
      ? "text-black"
      : sanitize(backgroundColor) === "pattern"
        ? ""
        : lightMode
          ? "text-black"
          : "";

  const blockProps = {
    backgroundColor,
    bottom,
    colorStarter,
    componentId,
    heading,
    lightMode,
    primaryEnder,
  };

  return (
    <BlockWrapper
      {...blockProps}
      className={`richText${className ? ` ${className}` : ""}`}
    >
      <Portable
        className={`md:max-w-[670px] mx-auto px-4 text-center ${boxStyles}`}
        headingClasses={boxHeadingStyles}
        content={props.copy}
      />
      {links && links.length > 0 && (
        <div className="flex items-center justify-center mt-8 gap-4 flex-wrap">
          {links.map((link, index) => {
            return (
              <a
                className={`button text-center ${lightMode ? "secondary" : "tertiary"}`}
                key={link._key + index}
                href={link.href}
                rel={isExternal(link.href) ? "noreferrer noopener" : undefined}
                target={isExternal(link.href) ? "_blank" : undefined}
              >
                {link.copy}
              </a>
            );
          })}
        </div>
      )}
    </BlockWrapper>
  );
};
